
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import MatchinPayHistory from "@/components/matchinpay/MatchinPayHistory.vue";
import MatchinPayReload from "@/components/matchinpay/MatchinPayReload.vue";
import { getCurrentUser } from "../../utils/index";
import { ecShopAdvisoryVisibility } from "@/api/common";

export default defineComponent({
  name: "matchinpayhistory",
  components: {
    MatchinPayHistory,
    MatchinPayReload,
  },
  data() {
    return {
      pt: "",
      ccode: -1,
      current_usid: "" as string,
      isOverriden: false,
    };
  },
  methods: {
    hideECShopAdvisory() {
      ecShopAdvisoryVisibility.hide();
    },
    showECShopAdvisory() {
      ecShopAdvisoryVisibility.show();
    },
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("MG Pay");
    });
  },
  mounted() {
    let user = getCurrentUser();

    if (user !== undefined) {
      this.current_usid = user.usid;
    }
    this.ccode = Number(localStorage.getItem("ccode"));
    this.pt = String(localStorage.getItem("pt"));
    if (localStorage.getItem("override_cifid") != null) {
      this.isOverriden = true;
    }

    this.hideECShopAdvisory();
  },
  unmounted() {
    this.showECShopAdvisory();
  },
});
